import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inbound_order_audit_report_headerService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number }): 
  Promise<{ result: { Id?: number, Employee?: string, Order?: { LookupCode?: string, reportRecibidor?: string, reportSupervisor?: string, Account?: { LookupCode?: string, Name?: string } }, Project?: { LookupCode?: string }, Shipment?: { ShippedDate?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Employee?: string, Order?: { LookupCode?: string, reportRecibidor?: string, reportSupervisor?: string, Account?: { LookupCode?: string, Name?: string } }, Project?: { LookupCode?: string }, Shipment?: { ShippedDate?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Employee?: string, Order?: { LookupCode?: string, reportRecibidor?: string, reportSupervisor?: string, Account?: { LookupCode?: string, Name?: string } }, Project?: { LookupCode?: string }, Shipment?: { ShippedDate?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number    }) {
      return false;
    }
}
